import React from "react"

import { IconButton, Tooltip } from "@mui/material"

export const FuncMiniButton = (props: {
	label: string
	onClick: () => void
	icon: React.ReactElement
	hoverColor: string
}) => (
	<Tooltip title={props.label} placement="bottom-start" enterDelay={1000} leaveDelay={100}>
		<IconButton size="small" aria-label={props.label} onClick={props.onClick}>
			{props.icon}
		</IconButton>
	</Tooltip>
)
